// src/pages/AccessDenied.js

import React from 'react';
import { useNavigate } from 'react-router-dom';

const AccessDenied = () => {
    const navigate = useNavigate();

    return (
        <div className="access-denied-container">
            <h2>Accès Refusé</h2>
            <p>Vous n'avez pas l'autorisation d'accéder à cette page.</p>
            <button onClick={() => navigate('/login')}>Retourner à la connexion</button>
        </div>
    );
};

export default AccessDenied;
